import { defaultMessageBackend } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--jira-empanada/jira-filter-refinement-filter-button';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren } from 'react';

import { FilterRefinementSpotlightCard } from './spotlight-card';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';

// Currently we won't look into the message backend, but this is where you can add stages which
// change your message before it gets sent to the frontend.
export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ children, isEnabled }: PropsWithChildren<MessageTemplateContext>) => {
			if (!isEnabled) {
				return <>{children}</>;
			}

			return <FilterRefinementSpotlightCard>{children}</FilterRefinementSpotlightCard>;
		},
	},
});
